<div class="wrapper">
  @if (isLoading || !canEmbed) {
    <div class="control-page">
      @if (isLoading) {
        <div class="loading-badge">
          <my-spinner></my-spinner>
        </div>
      }
      @if ((!isLoading && !canEmbed)) {
        <div class="embed-failed">
          <p class="ban"><i class="fa fa-ban"></i></p>
          <h4>{{ 'Sorry, this content cannot be embedded' | translate }}</h4>
        </div>
      }
    </div>
  }
  @if ((!isLoading && canEmbed)) {
    <iframe [src]="embedUrl" allowfullscreen title=""></iframe>
  }
  @if ((!isLoading && canEmbed)) {
    <my-fullscreen-button class="toggleFullscreen"></my-fullscreen-button>
  }
</div>
